import React from 'react';
import SEO from '@/components/SEO';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <>
      <SEO
        title="Contact Us - AssetWise Business Consultants"
        description="Get in touch with AssetWise Business Consultants. Located in Mira Road, Thane. Contact us for loans, real estate, and legal advisory services."
        path="/contact"
        keywords="contact loan consultant, Mira Road financial services, AssetWise contact, loan enquiry Thane"
      />
      
      <div className="pt-20">
        <Contact />
      </div>
    </>
  );
};

export default ContactPage;
